export const environment = {
  production: true,
  api: "https://api-partners.bancobmg.com.br/central-atendimento/v1",
  apiGateway: "https://api-partners.bancobmg.com.br",
  adobeLaunchURL: 'https://assets.adobedtm.com/d9f2ffc2b58e/a598b164c3f9/launch-cc9653cbe2d3-development.min.js',
  credential: 'N2VjOTdmMWMtZDNhMi00MDFmLTg0YTUtNjg4ZWU3YjEwNjIzOjlmMzAyMDVhLWE3NDctNGViNC1iOTMyLTk5MjdlZDUwMGQ2Ng=='
};

// export const environment = {
//   production: true,
//   api: "https://apisandbox.bancobmg.com.br:8443/hml/api/v1/central-atendimento",
//   apiGateway: "https://apisandbox.bancobmg.com.br:8443/api/v1",
//   adobeLaunchURL: 'https://assets.adobedtm.com/d9f2ffc2b58e/a598b164c3f9/launch-cc9653cbe2d3-development.min.js',
//   clientId: 'l767ce2de3fe304063aeefef768bc48bd3',
//   clientSecret: 'def9f0fcb1264cdfb9274d4c9e67d37a'
// };
